export default __webpack_public_path__ + "static/2248-b715a8b3e327faf556a30cb282f3002a.gif";